// src/lib/canonicalUrl.ts

/**
 * Generate a canonical URL for the current page
 * @param path The current path
 * @param queryParams Optional query parameters to include
 * @returns The canonical URL
 */
export function getCanonicalUrl(
  path: string,
  queryParams?: Record<string, string>,
): string {
  const baseUrl = 'https://hoptira.com';
  let url = `${baseUrl}${path}`;

  // Add query parameters if specified
  if (queryParams && Object.keys(queryParams).length > 0) {
    const params = new URLSearchParams();
    Object.entries(queryParams).forEach(([key, value]) => {
      params.append(key, value);
    });
    url += `?${params.toString()}`;
  }

  return url;
}

/**
 * Sets the canonical URL meta tag
 * @param url The URL to set as canonical
 */
export function setCanonicalUrl(url: string): void {
  // Remove any existing canonical URL tags
  const existingCanonical = document.querySelector('link[rel="canonical"]');
  if (existingCanonical) {
    existingCanonical.remove();
  }

  // Create a new canonical URL tag
  const link = document.createElement('link');
  link.rel = 'canonical';
  link.href = url;
  document.head.appendChild(link);
}

/**
 * Update the canonical URL for the current page
 * @param path The current path
 * @param queryParams Optional query parameters to include
 */
export function updateCanonicalUrl(
  path: string,
  queryParams?: Record<string, string>,
): void {
  const url = getCanonicalUrl(path, queryParams);
  setCanonicalUrl(url);
}
